<p-dialog
    [(visible)]="visible"
    [header]="header()"
    [modal]="modal()"
    [closable]="closable() && !busy()"
    [closeOnEscape]="closeOnEscape() && !busy()"
    [dismissableMask]="dismissableMask() && !busy()"
    [draggable]="draggable()"
    [resizable]="resizable()"
    [maximizable]="maximizable()"
    [blockScroll]="blockScroll()"
    [position]="position()"
    [styleClass]="styleClass() ?? ''"
    (onShow)="shown.emit()"
    (onHide)="hidden.emit()"
>
    @if (headlessTemplate()) {
        <ng-template #headless>
            <ng-container *ngTemplateOutlet="headlessTemplate()!" />
        </ng-template>
    } @else {
        @if (headerTemplate()) {
            <ng-template #header>
                <ng-container *ngTemplateOutlet="headerTemplate()!" />
            </ng-template>
        }

        <ng-content />

        @if (footerTemplate()) {
            <ng-template #footer>
                <ng-container *ngTemplateOutlet="footerTemplate()!" />
            </ng-template>
        }
    }
</p-dialog>
